module.exports = __webpack_public_path__ + "static/media/plusOutlined.28c2b522.svg";